import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-vip-badge',
  templateUrl: './vip-badge.component.html',
  styleUrls: ['./vip-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VipBadgeComponent {}
